import store from '../../../store';
import { actions as stepsActions } from '../../../reducers/steps';
import { actions as exerciseSetActions } from '../../../reducers/exerciseSet';
import { actions as rewardSystemActions } from '../../../reducers/rewardSystem';

function finishExercise() {
  store.dispatch(
    stepsActions.set(
      ['step4', 'office', 'exercises', 'handingOverExercise5', 'overlay'],
      false
    )
  );
  const exercisePoints = store.getState().rewardSystem.currentExercisePoints;

  // check if arleady answered
  const currentExercise = store.getState().exerciseSet.currentExerciseSet;
  const currentExerciseSet = store.getState().exerciseSet[currentExercise];

  if (currentExerciseSet.handingOverExercise4 === false) {
    store.dispatch(rewardSystemActions.increment('step4', exercisePoints));
    store.dispatch(
      exerciseSetActions.closeExercise(['handingOver', 'handingOverExercise4'])
    );
  }
}

export default {
  flow: {
    0: {
      type: 'info',
      subline: 'Wortschatz',
      headline: 'Tätigkeiten beschreiben',
      text:
        'Was sollten die Patienten tun? Kennen Sie die richtigen Kombinationen?',
      duration: 'DAUER: 2 MIN',
      goTo: '1'
    },
    1: {
      type: 'questionSet',
      category: 'vocabulary',
      questions: [
        {
          title: 'Welches Verb passt zum Nomen? Wählen Sie aus.',
          question: 'auf die Ernährung …',
          correct: 'Gute Antwort, weiter so!',
          incorrect: 'Leider keine optimale Antwort.',
          multiple: false,
          answers: [
            {
              id: 1,
              data: 'einnehmen'
            },
            {
              id: 2,
              data: 'tragen'
            },
            {
              id: 3,
              data: 'einhalten'
            },
            {
              id: 4,
              meta: { correct: 4 },
              data: 'achten'
            }
          ]
        },
        {
          title: 'Welches Verb passt zum Nomen? Wählen Sie aus.',
          question: 'eine Diät …',
          correct: 'Gute Antwort, weiter so!',
          incorrect: 'Leider keine optimale Antwort.',
          multiple: false,
          answers: [
            {
              id: 1,
              data: 'einnehmen'
            },
            {
              id: 2,
              data: 'verzichten'
            },
            {
              id: 3,
              meta: { correct: 3 },
              data: 'einhalten'
            },
            {
              id: 4,
              data: 'achten'
            }
          ]
        },
        {
          title: 'Welches Verb passt zum Nomen? Wählen Sie aus.',
          question: 'Stress ...',
          correct: 'Gute Antwort, weiter so!',
          incorrect: 'Leider keine optimale Antwort.',
          multiple: false,
          answers: [
            {
              id: 1,
              data: 'verzichten'
            },
            {
              id: 2,
              data: 'tragen'
            },
            {
              id: 3,
              data: 'achten'
            },
            {
              id: 4,
              meta: { correct: 4 },
              data: 'vermeiden'
            }
          ]
        },
        {
          title: 'Welches Verb passt zum Nomen? Wählen Sie aus.',
          question: 'die Medikamente regelmäßig …',
          correct: 'Gute Antwort, weiter so!',
          incorrect: 'Leider keine optimale Antwort.',
          multiple: false,
          answers: [
            {
              id: 1,
              meta: { correct: 1 },
              data: 'einnehmen'
            },
            {
              id: 2,
              data: 'verzichten'
            },
            {
              id: 3,
              data: 'einhalten'
            },
            {
              id: 4,
              data: 'achten'
            }
          ]
        },
        {
          title: 'Welches Verb passt zum Nomen? Wählen Sie aus.',
          question: 'auf Alkohol …',
          correct: 'Gute Antwort, weiter so!',
          incorrect: 'Leider keine optimale Antwort.',
          multiple: false,
          answers: [
            {
              id: 1,
              data: 'einnehmen'
            },
            {
              id: 2,
              meta: { correct: 2 },
              data: 'verzichten'
            },
            {
              id: 3,
              data: 'einhalten'
            },
            {
              id: 4,
              data: 'vermeiden'
            }
          ]
        },
        {
          title: 'Welches Verb passt zum Nomen? Wählen Sie aus.',
          question: 'nichts Schweres …',
          correct: 'Gute Antwort, weiter so!',
          incorrect: 'Leider keine optimale Antwort.',
          multiple: false,
          answers: [
            {
              id: 1,
              data: 'verzichten'
            },
            {
              id: 2,
              meta: { correct: 2 },
              data: 'tragen'
            },
            {
              id: 3,
              data: 'einhalten'
            },
            {
              id: 4,
              data: 'achten'
            }
          ],
          after: () => {
            finishExercise();
          }
        }
      ]
    }
  }
};
